import React, { useLayoutEffect } from "react";
import { useIntl } from "react-intl";

import Card from "../../UI/Card/Card";
import Section from "../../UI/Others/Section";
import NoteCard from "../../UI/Card/NoteCard";
import Headline from "../../Headline/Headline";
//import EmptyState from "../../UI/State/EmptyState";

import LinkButton from "../../UI/Button/LinkButton";
import ExtLinkButton from "../../UI/Button/ExternalLinkButton";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCode, faBook, faUsers, faLock, faComments, faDownload, faPhone, faShoppingCart, faCog, faChartBar, faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import { faCreditCard} from "@fortawesome/free-regular-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

const Apis = () => {
    const intl = useIntl();

    const title = intl.messages.apiTitle;
    const subtitle = intl.messages.apiMessage;
    const getting_started = "doc/rest/Getting_Started";

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    function SDKCard(props) {
        return (
            <div className="d-flex col-lg-6">
                <NoteCard title={props.title} icon={props.icon} colorIcon="pink">
                    {props.children}
                </NoteCard>
            </div>
        );
    }

    let cardCliAction = <div>
        <LinkButton className="btn-blue mb-2"
            to="doc/sdk/cli/tutorials/Getting_started"
            label={intl.messages.apiBtn3}
            icon={faBook}
        />

        <ExtLinkButton className="btn-green ml-2 mb-2"
            link="https://www.npmjs.com/package/rainbow-cli"
            label="Rainbow CLI"
            icon={faDownload}
        />
    </div>

    let cardS2SAction = <div>
        <LinkButton className="btn-blue mb-2"
            to="doc/sdk/s2s-starterkit-nodejs/guides/Getting_Started"
            label={intl.messages.apiBtn2}
            icon={faBook}
        />
        <ExtLinkButton className="btn-orange ml-2 mb-2"
            link="https://github.com/Rainbow-CPaaS/Rainbow-S2S-StarterKit-NodeJS"
            label={intl.messages.apiBtn5}
            icon={faGithub}
        />

        <ExtLinkButton className="btn-orange ml-2 mb-2"
            link="https://github.com/Rainbow-CPaaS/Rainbow-S2S-Samples"
            label={intl.messages.apiBtn4}
            icon={faCode}
        />
    </div>

    let cardRestAction = <div>
        <LinkButton className="btn-blue mb-2"
            to={getting_started}
            label={intl.messages.apiBtn1}
            icon={faBook}
        />
    </div>

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <div className="row">
                <div className="d-flex col-lg-6">
                    <Card title={intl.messages.apiCardTitle1} action={cardRestAction}>
                        <div className="card-text">{intl.messages.apiCardTxt4} <br /><br /></div>
                    </Card>
                </div>

                <div className="d-flex col-lg-6">
                    <Card title={intl.messages.apiCardTitle2}>
                        <div className="card-text">{intl.messages.apiCardTxt2}<br/><br/>{intl.messages.apiCardTxt22}<br/><br/>
                            <ul className="list-unstyled">
                                <b>{intl.messages.apiListItem1}</b>
                                <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />{intl.messages.apiListItem2}</li>
                                <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />{intl.messages.apiListItem3}</li>
                                <li><FontAwesomeIcon icon={faArrowRight} className="pr-2 text-pink" size="lg" />{intl.messages.apiListItem4}</li>
                            </ul>
                        </div>
                    </Card>
                    {/* <Card
                        title="RAINBOW REST API Channel"
                        subtitle="[version] - date" 
                        footer="Last updated xxx"
                    >
                        <div className="card-text"><EmptyState icon={faNewspaper} desc="nimia in peiores haeserat plagas" /></div>
                    </Card> */}
                </div>
            </div>

            <div className="row">
                <div className="col-lg-6 d-flex">
                    <Card title={intl.messages.apiCardTitle3} action={cardS2SAction}>
                        <div className="card-text">{intl.messages.apiCardTxt3}<br/><br/></div>
                    </Card>
                </div>
                <div className="col-lg-6 d-flex">
                    <Card title={intl.messages.apiCardTitle5} action={cardCliAction}>
                        <div className="card-text">{intl.messages.apiCardTxt5}<br/><br/></div>
                    </Card>
                </div>
            </div>

            <Section 
                title={intl.messages.apiGlanceTitle} 
                message={intl.messages.apiGlanceMessage} 
                className="bg-pink"
            />
            
            <div className="row">
                <SDKCard title={intl.messages.apiGlanceSubTitle1} icon={faExchangeAlt}>{intl.messages.apiGlanceSubTxt1}</SDKCard>
                <SDKCard title={intl.messages.apiGlanceSubTitle2} icon={faLock}>{intl.messages.apiGlanceSubTxt2}</SDKCard>
            </div>

            <div className="row">
                <SDKCard title={intl.messages.apiGlanceSubTitle3} icon={faCog}>{intl.messages.apiGlanceSubTxt3}</SDKCard>
                <SDKCard title={intl.messages.apiGlanceSubTitle4} icon={faPhone}>{intl.messages.apiGlanceSubTxt4}</SDKCard>
            </div>

            <div className="row">
                <SDKCard title={intl.messages.apiGlanceSubTitle5} icon={faShoppingCart}>{intl.messages.apiGlanceSubTxt5}</SDKCard>
                <SDKCard title={intl.messages.apiGlanceSubTitle6} icon={faCreditCard}>{intl.messages.apiGlanceSubTxt6}</SDKCard>
            </div>

            <div className="row">
                <SDKCard title={intl.messages.apiGlanceSubTitle7} icon={faChartBar}>{intl.messages.apiGlanceSubTxt7}</SDKCard>
                <SDKCard title={intl.messages.apiGlanceSubTitle8} icon={faCode}>{intl.messages.apiGlanceSubTxt8}</SDKCard>
            </div>

            <div className="row">
                <SDKCard title={intl.messages.apiGlanceSubTitle9} icon={faUsers}>{intl.messages.apiGlanceSubTxt9}</SDKCard>
                <SDKCard title={intl.messages.apiGlanceSubTitle10} icon={faComments}>{intl.messages.apiGlanceSubTxt10}</SDKCard>
            </div>
        </div>
    );
}

export default Apis;